import { INGREDIENT_RISK_REPORT_GENERATED } from 'common/messages';
import templateUrl from './ingredient-risk.html';

export default {
  templateUrl,
  bindings: {
  },
  controller: class IngredientRiskComponent {
    constructor(LoadingService, IngredientRiskService, ToastService) {
      'ngInject';

      Object.assign(this, {
        LoadingService,
        IngredientRiskService,
        ToastService
      });
    }

    downloadReport() {
      if (this.selectedIngredient) {
        this.LoadingService.start();

        this.IngredientRiskService.getReport(this.selectedIngredient.SystemIngredientId)
          .then(() => this.ToastService.showSuccess(INGREDIENT_RISK_REPORT_GENERATED))
          .catch(error => this.ToastService.showError(error))
          .finally(() => this.LoadingService.stop());
      }
    }

    selectedIngredientChanged({ selectedIngredient }) {
      this.selectedIngredient = selectedIngredient;
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/reports/ingredient-risk/ingredient-risk.component.js